module.exports = __webpack_public_path__ + "static/media/no_products.0e7a753a.png";